import React from "react";
import Toggle from "../Inputs/Toggle";
import ButtonSkaRound from "../Buttons/ButtonSkaRound";
const CallLinkCard = ({ titleElement, maxHeight, childElements, disabled, children, flexGrow }) => {
    // titleElement: {title, checked, onChange, onClick }
    return <div className="CallLinkCardContainer" style={{ flexGrow: flexGrow ? flexGrow : null, maxHeight: maxHeight ? maxHeight : null }}>
        <div style={{ display: "flex", flexDirection: "row", gap: "10px", fontSize: "22px", fontWeight: "600", borderRadius: "6px 6px 0px 0px", color: disabled ? "var(--grey-base)" : "var(--carbone)", padding: "20px", width: "calc(100%-40px)", backgroundColor: "var(--grey-lighter)" }}>
            { titleElement && titleElement.checked !== undefined ? <Toggle
                type="switch"
                disabled={disabled}
                checked={titleElement.checked}
                onClick={titleElement.onChange}
            /> : null}
            { titleElement.title }
        </div>
        { childElements ? childElements.map((child, index) => {
            return <div className="CallLinkCardContent" key={index}
                style={{ margin: "20px", color: disabled ? "var(--grey-base)" : "var(--carbone)" }}
            >
                { child.title }
                <span style={{ flexGrow: 1 }}/>
                {
                    child.checked !== undefined ? <Toggle
                        type="switch"
                        disabled={disabled}
                        checked={child.checked}
                        onClick={child.onChange}
                    /> : null
                }
                {
                    child.onAction ? <ButtonSkaRound
                        type={child.actionType}
                        isDisabled={disabled}
                        nameIcon={child.actionIcon}
                        onClick={child.onAction}
                    /> : null
                }
            </div>;
        }) : null}
        {children ? <div style={{ display: "flex", flexDirection: "column", gap: "0px", width: "calc(100% - 40px)", padding: "20px", fontSize: "14px" }}>
            {
                children
            }
        </div> : null}
    </div>;
};
export default CallLinkCard;
